import { render } from "./GeoBlock.vue?vue&type=template&id=4c7be107&scoped=true"
import script from "./GeoBlock.vue?vue&type=script&lang=js"
export * from "./GeoBlock.vue?vue&type=script&lang=js"

import "./GeoBlock.vue?vue&type=style&index=0&id=4c7be107&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7be107"]])

export default __exports__